var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.coIsAppointment
        ? [
            _vm.self
              ? _c(
                  "base-control-label",
                  {
                    attrs: {
                      required: "",
                      label: _vm.$t(_vm.lblSetting.agendaTicket)
                    }
                  },
                  [
                    _c("base-autocomplete", {
                      attrs: {
                        disabled: _vm.isUpdating,
                        clearable: !_vm.isUpdating,
                        "default-text": _vm.dtDefaultText,
                        error: _vm.dtRequireTicket,
                        rules: _vm.dtRules.ticketRules,
                        options: _vm.coTickets,
                        "item-value": "id",
                        "return-object": true,
                        "item-text": "subject",
                        "on-fetch-remote": _vm.handeGetTicketsAutocomplete
                      },
                      on: { change: _vm.handleTicketChange },
                      model: {
                        value: _vm.appointmentFkTicket,
                        callback: function($$v) {
                          _vm.appointmentFkTicket = $$v
                        },
                        expression: "appointmentFkTicket"
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "base-control-label",
              {
                attrs: {
                  required: _vm.dtIndependentContractorResources.length > 0,
                  label: _vm.$tc(_vm.lblSetting.agendaIndependentContractor, 2)
                }
              },
              [
                _c("base-multi-select", {
                  attrs: {
                    rules: _vm.dtRules.independentContractorRules,
                    disabled: _vm.canAddIC,
                    "return-object": false,
                    options: _vm.dtIndependentContractorResources
                  },
                  model: {
                    value: _vm.coIndependentContractors,
                    callback: function($$v) {
                      _vm.coIndependentContractors = $$v
                    },
                    expression: "coIndependentContractors"
                  }
                }),
                _vm._v(" "),
                _vm.self
                  ? _c(
                      "a",
                      {
                        staticClass: "application__button--no-decoration",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.handleRedirectToTicket }
                      },
                      [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.agendaRedirectTo)))]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "base-control-label",
              { attrs: { label: _vm.$tc(_vm.lblSetting.agendaWelcoming, 2) } },
              [
                _vm.coDeclarants
                  ? _c("base-multi-select", {
                      attrs: {
                        "item-value": "id",
                        "return-object": false,
                        options: _vm.coDeclarants,
                        fetch: _vm.handleSearchWelcoming
                      },
                      model: {
                        value: _vm.coWelcomings,
                        callback: function($$v) {
                          _vm.coWelcomings = $$v
                        },
                        expression: "coWelcomings"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-control-label",
        { attrs: { required: "", label: _vm.$t(_vm.lblSetting.agendaName) } },
        [
          _c("v-text-field", {
            attrs: {
              placeholder: _vm.$t(_vm.lblSetting.agendaTitlePlaceholder),
              rules: _vm.dtRules.nameRules,
              flat: ""
            },
            model: {
              value: _vm.appointmentName,
              callback: function($$v) {
                _vm.appointmentName = $$v
              },
              expression: "appointmentName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "base-control-label",
        { attrs: { label: _vm.$t(_vm.lblSetting.lblDescription) } },
        [
          _c("v-textarea", {
            attrs: { flat: "", name: "appointment-description", rows: 2 },
            model: {
              value: _vm.appointmentDescription,
              callback: function($$v) {
                _vm.appointmentDescription = $$v
              },
              expression: "appointmentDescription"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.self
        ? _c(
            "base-control-label",
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs6: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            disabled:
                              _vm.isUpdating || _vm.canCreateAppointment,
                            round: "",
                            outline: !_vm.coIsAppointment
                          },
                          on: {
                            click: function($event) {
                              _vm.handleChangeType(_vm.typeAppointment)
                            }
                          }
                        },
                        [
                          _c(
                            "strong",
                            {
                              style: _vm.getStyleForAppointmentTypeButton(
                                _vm.typeAppointment
                              )
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t(_vm.lblSetting.agendaAppointment))
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs6: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "secondary",
                            disabled: _vm.isUpdating || _vm.canCreateEvent,
                            round: "",
                            outline: _vm.coIsAppointment
                          },
                          on: {
                            click: function($event) {
                              _vm.handleChangeType(_vm.typeEvent)
                            }
                          }
                        },
                        [
                          _c(
                            "strong",
                            {
                              style: _vm.getStyleForAppointmentTypeButton(
                                _vm.typeEvent
                              )
                            },
                            [_vm._v(_vm._s(_vm.$t(_vm.lblSetting.agendaEvent)))]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "base-control-label",
            {
              attrs: {
                xs4: "",
                label:
                  _vm.$t(_vm.lblSetting.agendaStart) +
                  " - " +
                  _vm.$t(_vm.lblSetting.agendaEnd)
              }
            },
            [
              _c("base-datetime-picker-range", {
                attrs: { step: _vm.dtStep },
                model: {
                  value: _vm.coDates,
                  callback: function($$v) {
                    _vm.coDates = $$v
                  },
                  expression: "coDates"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-142285b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-142285b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/agenda/components/agenda-modal/template.html
// module id = null
// module chunks = 